import script from "./ProjectList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=0fb6f69b&lang=css"

const __exports__ = script;

export default __exports__